import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Box, Typography, Skeleton } from '@mui/material';
import { BarChart, CustomButtonGroup } from '../../../shared';
import { CHART_OPTIONS } from './constants';
import { actions } from '../../../../redux/reducers/totalEngagementReducer';


function PhysicianEngagement() {
    const dispatch = useDispatch();
    const { clickEngagement, isLoading } = useSelector((state) => state.totalEngagement);
    const { setPhysicianEngagementChannel, setPhysicianEngagementData } = actions;
    const handleChannel = (option) => {
        dispatch(setPhysicianEngagementChannel(option));
        dispatch(setPhysicianEngagementData(option));
    };

    return (
        <> <Grid className='border-container'>
            <Box className="flex-column padding-24px border-bottom-gray gap-8">
                <Box>
                    <Typography className='text-lg-semi-bold gray-900'>
                        Physician Engagement by Channels
                    </Typography>
                </Box>

                <Box>
                    { isLoading 
                        ? <Skeleton height={40} variant='rectangular' width={'100%'}/>
                        : clickEngagement.labels.length > 1 ? (<CustomButtonGroup
                            customStyle={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                gap: '8px'
                            }}
                            data={clickEngagement.labels}
                            handleClick={(option) => handleChannel(option)}
                            isToolTip={true}
                            key="total-physician-engagement-by-channels"
                            selected={clickEngagement.selectedChannel}
                        />) : null
                    }
                </Box> 
            </Box>

            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Box className="padding-24px height-343px physician-engagement-channels">
                        { isLoading ? <Skeleton height='100%' variant="rectangular" width='100%' /> : 
                            <BarChart
                                chartOptions={
                                    {
                                        ...CHART_OPTIONS, 
                                        xaxis: {
                                            ...CHART_OPTIONS.xaxis,
                                            categories: clickEngagement.selectedChannel === 'All' ? [...clickEngagement.categoriesForAll] : [...clickEngagement.categories]
                                        },
                                        yaxis: {
                                            ...CHART_OPTIONS.yaxis,
                                            max: clickEngagement.yMax
                                        },
                                        colors: clickEngagement.colors,
                                        chart: clickEngagement.selectedChannel === 'All' ? CHART_OPTIONS.chart : { stacked: false, toolbar: { show: false } }
                                    }
                                }
                                chartSeries={clickEngagement.series}
                            /> 
                        }
                    </Box>
                </Grid>
            </Grid>
        </Grid>
        </>
    );
}

export default PhysicianEngagement;
